import { isArticleInCountry } from "../shared/utils/articleUtil"
import { removeDoubleSlash } from "../shared/utils/urlUril"

export const reduceArticleSlugs = ({ articles, countries, category = "" }) => {
  // get country info
  const getCountryInfo = locale =>
    countries.find(country => country.codigoIcu === locale)

  // get article info
  const getInfoArticleByCountry = locale =>
    articles.find(article => isArticleInCountry(article, locale))

  // create alternates
  const alternates = articles.reduce((acc, article) => {
    const localeSplited = article.node_locale.split("-")
    const country = localeSplited[1]
    const isValidCountry = isArticleInCountry(article, country)

    if (isValidCountry) {
      const countryInfo = getCountryInfo(article.node_locale)

      acc.push({
        rel: "alternate",
        hrefLang: article.node_locale,
        href: `${countryInfo.dominioDelPais || ""}${removeDoubleSlash(category + article.slug)}`,
      })
    }
    return acc
  }, [])

  // set default Alternates
  const haveActualCountry =
    alternates.find(alternate => alternate.hrefLang === process.env.LOCALE) || false

  const defaultCountry = haveActualCountry
    ? getCountryInfo(process.env.LOCALE)
    : getCountryInfo(alternates[0].hrefLang)

  const defaultArticleInfo = getInfoArticleByCountry(defaultCountry.codigoIcu)

  alternates.push({
    rel: "alternate",
    hrefLang: "x-default",
    href: `${defaultCountry.dominioDelPais}${removeDoubleSlash(category + defaultArticleInfo.slug)}`,
  })

  return alternates || null
}
